/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import Fab from '@mui/material/Fab';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ElementContainer = styled.div`
padding-top: 1rem;
padding-bottom: 1rem;
`;

